import { ApplicationState } from "../applicationState";

export const routeIdSelector = (state: ApplicationState): string => state.router.params!.customMedicalTypeId!;

export const pathSelector = (state: ApplicationState) => state.router.pathname;
